import axios from "axios";
export default {
    getObjects: () => axios.post("/Documents/GetObjects"),
    getMethods: () => axios.post("/Documents/GetMethods")
};
